import React from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import PageTabs from '../shared/PageTabs.jsx'
import '../../styles/pages.css'

const tabs = [
  { path: '/warehouse/receiving', label: 'Receiving' },
  { path: '/warehouse/testing', label: 'Testing' },
  { path: '/warehouse/partially-tested', label: 'Partially Tested' },
  { path: '/warehouse/repairs', label: 'Repairs' },
  { path: '/warehouse/issue-trades', label: 'Issue Trades' },
  { path: '/warehouse/to-send-back', label: 'To Send Back' },
  { path: '/warehouse/photography', label: 'Photography' },
  { path: '/warehouse/putaway', label: 'Putaway' },
  { path: '/warehouse/no-location', label: 'No Location' },
  { path: '/warehouse/shipping', label: 'Order Shipping' },
  { path: '/warehouse/manual-listing', label: 'Create Product' }
]

function WarehousePage() {
  const location = useLocation()
  const isHome = location.pathname === '/warehouse'

  // On home page, don't show the page header/tabs - WarehouseHome handles its own layout
  if (isHome) {
    return <Outlet />
  }

  return (
    <div className="page">
      <div className="pageHead">
        <h1>Warehouse</h1>
        <p>Physical warehouse operations and workflows</p>
      </div>

      {/* The inline overflowX/nowrap patch that used to live here is now the
          shared behaviour of every tab strip — see shared/PageTabs.jsx. */}
      <PageTabs tabs={tabs} match="exact" />

      <Outlet />
    </div>
  )
}

export default WarehousePage
